module.exports = "<p>\n  language-redirect works!\n</p>\n"